<template>
	<section class="flex">
		<section class="common-sub-top container">
			<section class="top-info-wrap">
				<div class="prev-wrap">
					<a @click="pageBefore()" class="prev"></a>
					<span class="name">화면모드 설정</span>
				</div>

				<div class="select-wrap">
					<div class="select" @click="changeSort">저장</div>
				</div>
			</section>
		</section>

		<section class="content layoutform">
			<div class="li">
				<div class="radio-group">
					<input type="radio" id="targetName" name="targetRadio" value="A" v-model="layoutSet" />
					<label for="targetName">자동</label>
				</div>
				<div class="radio-group">
					<input type="radio" id="targetCreated" name="targetRadio" value="V" v-model="layoutSet" />
					<label for="targetCreated">세로모드</label>
				</div>
				<div class="radio-group">
					<input type="radio" id="targetTest" name="targetRadio" value="H" v-model="layoutSet" />
					<label for="targetTest">가로모드</label>
				</div>
			</div>
		</section>

		<!-- msg 문구와 Ok 클릭 시 실행할 함수를 전달한다. -->
		<ModalOKCancel :propData="modalData" @okFunction="modalOKFunction" />
	</section>
</template>

<script>
import ModalOKCancel from '@/components/modal/ModalOKCancel.vue';
import { popOpenAndScrollNone } from '@/utils/UtilPopup';
export default {
	components: {
		ModalOKCancel
	},
	data: () => ({
		modalData: {
			id: 'SettingSortFormModal',
			msg: ''
		},
		layoutSet: ''
	}),
	mounted() {
		console.log(this.$store.state.settingInfo.layoutSet);
		this.layoutSet = this.$store.state.settingInfo.layoutSet;
	},
	methods: {
		pageBefore() {
			this.$router.go(-1);
		},
		modalOKFunction() {
			// 서식지 정렬 기준 저장
			console.log('Save');
		},
		changeSort() {
			this.modalData.msg = '저장되었습니다.';

			let json = JSON.stringify({
				layoutSet: this.layoutSet
			});
			this.$util.setOption(json);
			popOpenAndScrollNone(`#${this.modalData.id} .dim-popup-mark`, `#${this.modalData.id} .dim-popup-content`);

			try {
				var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
				if (varUA.match('android') != null) {
					window.penchart.callLayoutSet(this.layoutSet);
				} else if (varUA.indexOf('iphone') > -1 || varUA.indexOf('ipad') > -1 || varUA.indexOf('ipod') > -1) {
					//IOS 일때 처리
					window.webkit.messageHandlers.callLayoutSet.postMessage(this.layoutSet);
				}
			} catch (e) {
				console.log(e);
			}
		}
	}
};
</script>

<style scoped src="../../assets/css/setting.css"></style>
